import { h } from "preact";
import i18n from "../i18n.js";
import { classNames } from "../helpers.js";

export default function TalentState({ talent, ...props }) {
  if (!talent.state) return null;

  const text = i18n.t(`component.talent_state.${talent.state}`);

  switch (talent.state) {
    case "requested":
    case "declined":
    case "request_declined":
    case "hired":
    case "request_accepted":
    case "contacted":
    case "screened":
    case "replied":
      return (
        <span class={classNames("talent-state", props.class)}>{text}</span>
      );
    default:
      return null;
  }
}
